import _ from "../../../../lib/lodash.custom.min";
import {REQUEST_PARAM, INTERNAL_STATE} from "./config";
import {numFormat} from "../modules/util";

export default function paramMixin(obj, def) {
	// 内部で参照するためのalias
	// わかりづらい..?
	obj._def = def;

	const getters = {
		hashParam: function(){
			//this means store.state
			return {
				depAirport: this.depAirport,
				date: this.date,
				monthIndex: this.monthIndex,
				region0: this.region0,
				country0: this.country0,
				city0: this.city0,
				country1: this.country1,
				city1: this.city1,
				budget: this.budget,
				duration: this.duration,
				kodawari: this.kodawari,
				HotelMinPop: this.HotelMinPop,
				HotelMaxPop: this.HotelMaxPop,
				_onlyhere: this._onlyhere,
				_checkStock: this._checkStock,
				aroundmode: this.aroundmode,
				hotelname: this.hotelname,
				freeword: this.freeword,
				checkedHotel: this.checkedHotel,
				hotelSortForDetailBack: this.hotelSort
			};
		},
		queryString: function(){
			return objToQueryString(this.hashParam);
		},
		keyword: function() {
			const buf = [];
			if (!this.freeword && !this.hotelname) return "";

			if (this.freeword) {
				buf.push(this.freeword);
			}
			if (this.hotelname) {
				buf.push(this.hotelname);
			}
			return buf.join(" ");
		},
		matrix: function() {
			return matrixParam(this, this._def);
		},
		Hotels: function() {
			if (_.isEmpty(this.checkedHotel)) return null;
			return this.checkedHotel.join("-");
		},
		ca: function() {
			if (_.isEmpty(this.kodawari)) return null;
			return this.kodawari.join("-");
		},
		checkStock: function() {
			if (_.isEmpty(this._checkStock) ||
					this.monthIsSelected ||
					!this.date
					) return null;
			return "on";
		},
		onlyhere: function() {
			if (!_.isEmpty(this._onlyhere) && this.city0 && !this.country1) {
				return "1";
			}
			return null;
		},
		ymCurrent: function() {
			const idx = this.monthIndex;
			const months = this._def.months;
			return months[idx] && months[idx].yyyymm;
		},
		ymNext: function() {
			const idx = this.monthIndex;
			const months = this._def.months;
			return months[idx + 1] && months[idx + 1].yyyymm;
		},
		monthIsSelected: function() {
			return this.date && this.date.length === 6;
		},
		ym: function() {
			return this.monthIsSelected ? this.date : null;
		},
		detailSelected: function() {
			return _.some([
				!_.isEmpty(this.budget),
				this.ca,
				this.keyword,
				this.Hotels
			]);
		},
		kodawariCategories: function() {
			var count = this.ConditionState;
			var kodawari = _.map(count.attributeId, function(id, idx) {
				return {
					id: id,
					name: count.attributeName[idx],
					category: count.attributeCategory[idx],
					order: count.attributeOrder[idx],
					count: numFormat(count.courseAttrCount[id - 1] || 0)
				};
			});

			const categorizedKodawari = _.groupBy(kodawari, "category");
			_.each(categorizedKodawari, function(list, key) {
				categorizedKodawari[key] = _.sortBy(list, function(o) {
					return Number(o.order);
				});
			});
			return categorizedKodawari;
		},
		monIdxOfDate: function() {
			if (!this.date) { return 0; }
			const yyyymm = this.date.slice(0, 6);
			const idx =  _.findIndex(this._def.months, {yyyymm: yyyymm});
			return Math.max(0, idx);
		}
	};

	const functions = {
		getParam: function(command) {
			const param = {};
			REQUEST_PARAM.forEach((paramName) => {
				if (this[paramName]) {
					param[paramName] = this[paramName];
				}
			});
			const result = commandFilter(param, command);
			return result;
		},
		clear: function() {
			INTERNAL_STATE.forEach((paramName) =>{
				this[paramName] = null;
			});
		}
	};

	for (let key in getters) {
		Object.defineProperty(obj, key, {
			get: getters[key]
		});
	}

	for (let key in functions) {
		obj[key] = functions[key];
	}
}


export function convertServerParam(serverParam, def) {
	const result = {};
	const paramMap = {
		departure_code: (val) => ({depAirport: val}),
		AREA0: (val) => ({region0: val}),
		COUNTRY0: (val) => ({country0: val}),
		CITY0: (val) => ({city0: val}),
		PREFERENCE: (val) => ({kodawari: preferenceToList(val)}),
		checkStock: (val) => ({_checkStock: [val]}),
		DEPT_TIME: (val) => (deptTimeToDate(val, def)),
		KEYWORD: (val) => ({freeword: val})
	};

	for (let key in serverParam) {
		const obj = paramMap[key] ?
				paramMap[key](serverParam[key]):
				{[key]: serverParam[key]};
		Object.assign(result, obj);
	}

	return result;
}

export function preferenceToList(preference) {
	if (!preference) return;
	return preference.split("-").map((n) => String(n));
}

export function deptTimeToDate(deptTime, def) {
	if (!deptTime) return;
	// DEPT_TIMEはMMまたはMMDD
	if (deptTime.length === 2) { //MM
		const monthArray = def.months.map((m)=>(m.month));
		const monthIndex = monthArray.indexOf(Number(deptTime));
		return {
			monthIndex: monthIndex,
			date: def.months[monthIndex].yyyymm
		};
	} else if (deptTime.length === 4) { //MMDD
		for (let i = 0; i < def.calendar.length; i++) {
			const yyyymmdd = def.calendar[i].code;
			if (yyyymmdd.slice(4) === deptTime) {
				return {
					date: yyyymmdd
				};
			}
		}
	}
}


function objToQueryString(obj, separator="-") {
	const array = [];
	for(let key in obj ) {
		if (_.isNumber(obj[key]) || !_.isEmpty(obj[key])) {
			const value = _.isArray(obj[key]) ?
				obj[key].join(separator) + separator: obj[key];
			array.push(`${key}=${encodeURIComponent(value)}`);
		}
	}
	return array.join("&");
}


function commandFilter(param, command) {
	const result = _.clone(param);
	if (command === "RankingList") {
		delete result.depAirport;
	}
	if (command !== "CalendarState") {
		delete result.ymCurrent;
		delete result.ymNext;
	}
	return result;
}

export function matrixParam(state, def) {
	const budgetAll = def.budget.map((o) => (o.code));
	const durationAll = def.duration.map((o) => (o.code));
	const budget = _.isEmpty(state.budget) ? budgetAll : state.budget;
	const duration = _.isEmpty(state.duration) ? durationAll : state.duration;

	if (budget === budgetAll && duration === durationAll) return null;

	const matrixParams = [];
	budget.forEach((bd) => {
		duration.forEach((dr) => {
			matrixParams.push([bd, dr].join("-"));
		});
	});
	return matrixParams.join(".");
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/param.js